import { isEqual, pick } from 'lodash-es'

const state = {
  confirmData: null
}

const getters = {
  confirmData: state => state.confirmData,
  buyDataChanged: state => {
    if (state.confirmData?._before && state.confirmData?._after) {
      const compareKeys = [
        'routeType', // 线路
        'subRouteType', // 高性能线路
        'basePackageId', // 套餐
        'subBasePackageId', // 高性能套餐
        'buyTime', // 购买时长
        'buyTimeUnit', // 购买时长单位
        'ddosMax', // 弹性防护带宽
        'bandwidth', // 业务带宽
        'port', // 端口数
        'website', // 域名数
        'autoRenew' // 到期自动续费
      ]
      const beforeData = pick(state.confirmData._before, compareKeys)
      const afterData = pick(state.confirmData._after, compareKeys)
      return !isEqual(beforeData, afterData)
    } else {
      return !isEqual(state.confirmData?._before, state.confirmData?._after)
    }
  }
}

const mutations = {
  CLEAR_CONFIRM_DATA(state) {
    state.confirmData = null
  },
  SET_CONFIRM_DATA(state, val) {
    state.confirmData = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
